import React, { useState, Suspense, lazy } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import MovingStrip from './components/MovingStrip';
import ProjectsSection from './components/ProjectsSection';
import ClientLogos from './components/ClientLogos';
import Testimonials from './components/Testimonials';
import ConnectDialog from './components/ConnectDialog';
import useAnalytics from './hooks/useAnalytics';

// Below-the-fold sections — split out of initial bundle so the hero paints faster.
const IdeasSection = lazy(() => import('./components/IdeasSection'));
const BlogSection = lazy(() => import('./components/BlogSection'));
const GallerySection = lazy(() => import('./components/GallerySection'));
const AboutSection = lazy(() => import('./components/AboutSection'));
const AboutSection2 = lazy(() => import('./components/AboutSection2'));
const Footer = lazy(() => import('./components/Footer'));
const RecruiterCTA = lazy(() => import('./components/RecruiterCTA'));

// Subpages — only loaded when those routes are visited.
const ProjectsPage = lazy(() => import('./components/pages/ProjectsPage'));
const IdeasPage = lazy(() => import('./components/pages/IdeasPage'));
const BlogPage = lazy(() => import('./components/pages/BlogPage'));
const GalleryPage = lazy(() => import('./components/pages/GalleryPage'));

const Home = () => {
  const [isConnectOpen, setIsConnectOpen] = useState(false);
  useAnalytics();

  return (
    <>
      <Navigation onConnect={() => setIsConnectOpen(true)} />
      <Hero onConnect={() => setIsConnectOpen(true)} />
      <MovingStrip />
      <ClientLogos />
      <ProjectsSection />
      <Testimonials />
      <Suspense fallback={null}>
        <IdeasSection />
        <RecruiterCTA />
        <BlogSection />
        <GallerySection />
        <AboutSection />
        <AboutSection2 />
        <Footer onConnect={() => setIsConnectOpen(true)} />
      </Suspense>
      <ConnectDialog
        isOpen={isConnectOpen}
        onClose={() => setIsConnectOpen(false)}
      />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/ideas" element={<IdeasPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
